import { render, staticRenderFns } from "./XdhmCard.vue?vue&type=template&id=0aab0071&scoped=true&"
import script from "./XdhmCard.vue?vue&type=script&lang=js&"
export * from "./XdhmCard.vue?vue&type=script&lang=js&"
import style0 from "./XdhmCard.vue?vue&type=style&index=0&id=0aab0071&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab0071",
  null
  
)

export default component.exports